import React, { useCallback, useState, useEffect } from 'react';
import { useIntl } from "react-intl";
import './styles.scss';

const Select = ({ 
  options = [],
  onChange,
  querying = false,
  selectFirstIfEquals = ''
}) => {
  const [showBox, setShowBox] = useState(false);
  const [filterBoxes, setFilterBoxes] = useState('');
  const [selected, setSelected] = useState({ value: '', label: '' });
  const [boxes, setBoxes] = useState(options);
  const { formatMessage } = useIntl();

  useEffect(() => {
    onChange({ selected, query: filterBoxes });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected, filterBoxes])

  useEffect(() => {
    setBoxes([...options])

    if (selectFirstIfEquals !== '' 
      && options.length > 0 
      && options[0].label === selectFirstIfEquals
    ) {
      const isSelected = selected.value === options[0].value;

      if (!isSelected) {
        setSelected(options[0]);
        onChange({ selected: options[0], query: filterBoxes })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, formatMessage, selectFirstIfEquals])

  useEffect(() => {
    const sanitizedSearch = filterBoxes.replace(/([[\]()+{}?])/, '\\$1');
    const search = new RegExp(sanitizedSearch, 'i');

    if (!querying) {
      setBoxes(options.filter(item => search.test(item.label)));
    }
  }, [filterBoxes, options, querying])

  const handleSelected = useCallback(option => {
    const isAlreadySelected = selected.value === option.value;

    if (isAlreadySelected) setSelected({});
    else setSelected(option);
  }, [selected]);

  return (
    <div className="multiselect-component">
      <div className="selectbox" onClick={() => setShowBox(!showBox)}>
        <select>
          <option>
            {selected.label === '' 
              ? formatMessage({ id: 'selecione-um' }) 
              : selected.label}
          </option>
        </select>
        <div className="over-select"></div>
      </div>
      <div className={`${showBox ? 'display-multi-checkboxes' : 'hide-multi-checkboxes'}`}>
        <div className="search-input-select">
          <input 
            type="text" 
            placeholder={formatMessage({ id: 'procure-por-nome' })}
            onChange={(e) => setFilterBoxes(e.target.value)} 
          />
        </div>
        
        {boxes.map((option, _index) => (
          <label 
            key={_index} 
            htmlFor={option.value} 
            onClick={(e) => {
              e.preventDefault();
              handleSelected(option)
            }}
          >
            <input 
              type="checkbox" 
              checked={selected.value === option.value} 
              id={option.value}
              readOnly
            /> 

            {option.label}
          </label>
        ))}
      </div>
    </div>
  )
}

export default Select;